export const setOverviewInitStatus = "setOverviewInitStatus"
export const setOverviewPublishedDate = "setOverviewPublishedDate"
export const setTopProgramsLatestDayResults = "setTopProgramsLatestDayResults"
export const setTopProgramsSevenDaysResults = "setTopProgramsSevenDaysResults"
export const setSitesReachSevenDaysResults = "setSitesReachSevenDaysResults"
